import { ChangeDetectionStrategy, Component, HostBinding } from "@angular/core";

@Component({
    selector: "sps-conditional-field",
    template: `<ng-content></ng-content>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpsConditionalFieldComponent {
    static readonly displayName = "sps-conditional-field";
    static readonly props = {};

    @HostBinding("class.sps-conditional-field") readonly _spsConditionalFieldClass = true;
}
